@file:OptIn(InternalResourceApi::class)

package com.karyadina.common.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/com.karyadina.common.generated.resources/"

@delegate:ResourceContentHash(-184_220_411)
internal val Res.drawable.bg_persona_path: DrawableResource by lazy {
      DrawableResource("drawable:bg_persona_path", setOf(
        ResourceItem(setOf(), "${MD}drawable/bg_persona_path.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-337_527_409)
internal val Res.drawable.bhim_upi_: DrawableResource by lazy {
      DrawableResource("drawable:bhim_upi_", setOf(
        ResourceItem(setOf(), "${MD}drawable/bhim_upi_.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-169_844_621)
internal val Res.drawable.black_button: DrawableResource by lazy {
      DrawableResource("drawable:black_button", setOf(
        ResourceItem(setOf(), "${MD}drawable/black_button.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-573_165_948)
internal val Res.drawable.blue_button: DrawableResource by lazy {
      DrawableResource("drawable:blue_button", setOf(
        ResourceItem(setOf(), "${MD}drawable/blue_button.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-770_325_834)
internal val Res.drawable.bmc_button: DrawableResource by lazy {
      DrawableResource("drawable:bmc_button", setOf(
        ResourceItem(setOf(), "${MD}drawable/bmc_button.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-503_928_420)
internal val Res.drawable.bmc_full_logo: DrawableResource by lazy {
      DrawableResource("drawable:bmc_full_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/bmc_full_logo.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_274_712_367)
internal val Res.drawable.bmc_full_logo_no_background: DrawableResource by lazy {
      DrawableResource("drawable:bmc_full_logo_no_background", setOf(
        ResourceItem(setOf(), "${MD}drawable/bmc_full_logo_no_background.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(815_489_149)
internal val Res.drawable.bmc_logo: DrawableResource by lazy {
      DrawableResource("drawable:bmc_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/bmc_logo.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_546_374_919)
internal val Res.drawable.bmc_logo_no_background: DrawableResource by lazy {
      DrawableResource("drawable:bmc_logo_no_background", setOf(
        ResourceItem(setOf(), "${MD}drawable/bmc_logo_no_background.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_065_487_655)
internal val Res.drawable.bmc_logo_yellow: DrawableResource by lazy {
      DrawableResource("drawable:bmc_logo_yellow", setOf(
        ResourceItem(setOf(), "${MD}drawable/bmc_logo_yellow.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_249_998_947)
internal val Res.drawable.ddbhim_upi_: DrawableResource by lazy {
      DrawableResource("drawable:ddbhim_upi_", setOf(
        ResourceItem(setOf(), "${MD}drawable/ddbhim_upi_.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_484_096_551)
internal val Res.drawable.greeen_button: DrawableResource by lazy {
      DrawableResource("drawable:greeen_button", setOf(
        ResourceItem(setOf(), "${MD}drawable/greeen_button.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-211_191_866)
internal val Res.drawable.logo: DrawableResource by lazy {
      DrawableResource("drawable:logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(11_064_056)
internal val Res.drawable.orange_button: DrawableResource by lazy {
      DrawableResource("drawable:orange_button", setOf(
        ResourceItem(setOf(), "${MD}drawable/orange_button.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-125_447_394)
internal val Res.drawable.qr_code_bhim_upi: DrawableResource by lazy {
      DrawableResource("drawable:qr_code_bhim_upi", setOf(
        ResourceItem(setOf(), "${MD}drawable/qr_code_bhim_upi.jpeg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-132_174_019)
internal val Res.drawable.qr_code_buymecoffe: DrawableResource by lazy {
      DrawableResource("drawable:qr_code_buymecoffe", setOf(
        ResourceItem(setOf(), "${MD}drawable/qr_code_buymecoffe.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_451_137_229)
internal val Res.drawable.qrcode_ko_fi: DrawableResource by lazy {
      DrawableResource("drawable:qrcode_ko_fi", setOf(
        ResourceItem(setOf(), "${MD}drawable/qrcode_ko_fi.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-197_878_209)
internal val Res.drawable.red_button: DrawableResource by lazy {
      DrawableResource("drawable:red_button", setOf(
        ResourceItem(setOf(), "${MD}drawable/red_button.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_894_648)
internal val Res.drawable.support_me_on_kofi_badge_beige: DrawableResource by lazy {
      DrawableResource("drawable:support_me_on_kofi_badge_beige", setOf(
        ResourceItem(setOf(), "${MD}drawable/support_me_on_kofi_badge_beige.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-826_750_236)
internal val Res.drawable.violet_button: DrawableResource by lazy {
      DrawableResource("drawable:violet_button", setOf(
        ResourceItem(setOf(), "${MD}drawable/violet_button.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(421_125_976)
internal val Res.drawable.white_button: DrawableResource by lazy {
      DrawableResource("drawable:white_button", setOf(
        ResourceItem(setOf(), "${MD}drawable/white_button.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-46_781_986)
internal val Res.drawable.yellow_button: DrawableResource by lazy {
      DrawableResource("drawable:yellow_button", setOf(
        ResourceItem(setOf(), "${MD}drawable/yellow_button.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("bg_persona_path", Res.drawable.bg_persona_path)
  map.put("bhim_upi_", Res.drawable.bhim_upi_)
  map.put("black_button", Res.drawable.black_button)
  map.put("blue_button", Res.drawable.blue_button)
  map.put("bmc_button", Res.drawable.bmc_button)
  map.put("bmc_full_logo", Res.drawable.bmc_full_logo)
  map.put("bmc_full_logo_no_background", Res.drawable.bmc_full_logo_no_background)
  map.put("bmc_logo", Res.drawable.bmc_logo)
  map.put("bmc_logo_no_background", Res.drawable.bmc_logo_no_background)
  map.put("bmc_logo_yellow", Res.drawable.bmc_logo_yellow)
  map.put("ddbhim_upi_", Res.drawable.ddbhim_upi_)
  map.put("greeen_button", Res.drawable.greeen_button)
  map.put("logo", Res.drawable.logo)
  map.put("orange_button", Res.drawable.orange_button)
  map.put("qr_code_bhim_upi", Res.drawable.qr_code_bhim_upi)
  map.put("qr_code_buymecoffe", Res.drawable.qr_code_buymecoffe)
  map.put("qrcode_ko_fi", Res.drawable.qrcode_ko_fi)
  map.put("red_button", Res.drawable.red_button)
  map.put("support_me_on_kofi_badge_beige", Res.drawable.support_me_on_kofi_badge_beige)
  map.put("violet_button", Res.drawable.violet_button)
  map.put("white_button", Res.drawable.white_button)
  map.put("yellow_button", Res.drawable.yellow_button)
}
